import { OpenAIStream, StreamingTextResponse } from 'ai';

import { GptRequestInterface } from '@lessonPlanner/commons';
import { FeatureType } from '@lessonPlanner/constants';

import { request } from '../../../utils/fetch';

export interface StreamCompletionParams<T> {
  chatParams: GptRequestInterface<T, unknown>;
  promptname: string;
  abortController?: AbortController;
  feature?: FeatureType;
}

async function streamChatCompletion<T>(params: StreamCompletionParams<T>) {
  const { chatParams, abortController, promptname, feature } = params;
  const url = new URL(
    `/api/v1/gpt?promptname=${promptname}&feature=${
      feature ? encodeURIComponent(feature) : ''
    }`,
    process.env.NEXT_PUBLIC_EXTERNAL_BACKEND_URL,
  );

  const response = await request(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(chatParams),
    signal: abortController?.signal,
  });

  if (!response.ok) {
    const data = await response.json();
    console.error(data);
    const error = new Error(data.message || 'Something went wrong.');
    (error as any).statusCode = response.status;
    (error as any).raw = data.message;
    (error as any).code = data.code || 'gpt_api_error';
    throw error;
  }

  const stream = OpenAIStream(response);

  return new StreamingTextResponse(stream).body;
}

export { streamChatCompletion };
